import { SamplingHistory, BrandHistory, HistoryType, ApplianceHistory, SizeHistory, ApprovedHistory } from "@models/graphql";

export const isBrandHistory = (history: any): history is BrandHistory => history.type === HistoryType.Brand;
export const isApplianceHistory = (history: any): history is ApplianceHistory => history.type === HistoryType.Appliance;
export const isSizeHistory = (history: any): history is SizeHistory => history.type === HistoryType.Size;
export const isApprovedHistory = (history: any): history is ApprovedHistory => history.type === HistoryType.Approved;
